"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLpCfSlugGroupingsWithTypeFromMasterLoanTapes = exports.createLpCfSlugGroupings = exports.createCfToLpMap = exports.attachLoanTapeTypes = exports.getLoanTapeType = void 0;
/* eslint-disable no-restricted-syntax */
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const mesh = __importStar(require("../mesh"));
const getLoanTapeType = ({ loanProductSlugs, loanTapeTypeMap, }) => {
    const loanProductTypes = (0, remeda_1.pipe)(loanProductSlugs, (0, remeda_1.map)((slug) => {
        const loanTapeType = loanTapeTypeMap[slug];
        (0, common_1.finleyAssert)(loanTapeType, `loanTapeType must be defined for ${slug}`);
        return loanTapeType;
    }), (0, remeda_1.uniq)());
    (0, common_1.finleyAssert)(loanProductTypes.length === 1, new common_1.error.FinleyError('loanProductSlugs must be all of same loanTapeType', {
        metadata: {
            logMeta: {
                loanProductSlugs: JSON.stringify(loanProductSlugs),
                loanTapeTypeMap: JSON.stringify(loanTapeTypeMap),
            },
        },
    }));
    return loanProductTypes[0];
};
exports.getLoanTapeType = getLoanTapeType;
const attachLoanTapeTypes = ({ loanTapeTypeMap, lpCfSlugGroupings, }) => (0, remeda_1.map)(lpCfSlugGroupings, ({ creditFacilitySlugs, loanProductSlugs }) => {
    const loanTapeType = (0, exports.getLoanTapeType)({ loanProductSlugs, loanTapeTypeMap });
    return {
        loanProductSlugs,
        creditFacilitySlugs,
        loanTapeType,
    };
});
exports.attachLoanTapeTypes = attachLoanTapeTypes;
/**
 * Creates a map of cfToLps from artifact dependencies
 */
const createCfToLpMap = ({ outputArtifacts, inputArtifacts, dataTapeDependencies, }) => {
    (0, common_1.finleyAssert)(utils.hasCreditFacilitySlug(outputArtifacts), 'output artifacts must have loanProductSlug');
    (0, common_1.finleyAssert)(utils.hasLoanProductSlug(inputArtifacts), 'input artifacts must have loanProductSlug');
    const inputArtifactMap = (0, remeda_1.indexBy)(inputArtifacts, ({ id }) => id);
    return (0, remeda_1.reduce)(outputArtifacts, (cfToLpMap, outputArtifact) => {
        // eslint-disable-next-line no-param-reassign
        cfToLpMap[outputArtifact.creditFacilitySlug] = [];
        const edges = (0, remeda_1.filter)(dataTapeDependencies, (dep) => dep.outputArtifactId === outputArtifact.id);
        (0, remeda_1.forEach)(edges, (edge) => {
            const inputArtifact = inputArtifactMap[edge.inputArtifactId];
            (0, common_1.finleyAssert)(inputArtifact, `unable to create CfToLpMap, unknown input edge ${edge.inputArtifactId}`);
            cfToLpMap[outputArtifact.creditFacilitySlug].push(inputArtifact.loanProductSlug);
        });
        return cfToLpMap;
    }, {});
};
exports.createCfToLpMap = createCfToLpMap;
/**
 * Creates groupings of associated loanProductSlugs and creditFacilitySlugs
 *
 * Note: this can also operate on ids, not only slugs, consider renaming.
 */
const createLpCfSlugGroupings = (cfToLpMap) => {
    // reverse map cfToLpMap for easy lookup
    const lpToCfMap = mesh.createLpToCfMap(cfToLpMap);
    return mesh
        .getLpCfGroupings({ cfToLpMap, lpToCfMap })
        .map(({ loanProducts, creditFacilities }) => ({
        loanProductSlugs: loanProducts,
        creditFacilitySlugs: creditFacilities,
    }));
};
exports.createLpCfSlugGroupings = createLpCfSlugGroupings;
/**
 * This method should only be used when creating synthetic nodes, as
 * master loan tapes only have an ephemeral edge with receivable response tape
 * during synthetic node creation
 */
const getLpCfSlugGroupingsWithTypeFromMasterLoanTapes = ({ dbGraph, loanTapeTypeMap, }) => {
    const { dataTapes, dataTapeDependencies } = dbGraph;
    const masterLoanTapes = utils.filterMasterLoanTapes({ dataTapes });
    const receivableResponseTapes = utils.filterReceivableResponseTapes({
        dataTapes,
    });
    const cfToLpMap = (0, exports.createCfToLpMap)({
        outputArtifacts: receivableResponseTapes,
        inputArtifacts: masterLoanTapes,
        dataTapeDependencies,
    });
    const lpCfSlugGroupings = (0, exports.createLpCfSlugGroupings)(cfToLpMap);
    return (0, exports.attachLoanTapeTypes)({ lpCfSlugGroupings, loanTapeTypeMap });
};
exports.getLpCfSlugGroupingsWithTypeFromMasterLoanTapes = getLpCfSlugGroupingsWithTypeFromMasterLoanTapes;
//# sourceMappingURL=mesh.js.map